var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumb = function SvgThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 63 55"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Thumb_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.263,
    height: 23.87,
    x: 14,
    y: 14,
    fill: "#4BC6B6",
    rx: 11.935
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.55,
    height: 21.157,
    x: 15.356,
    y: 15.356,
    stroke: "#fff",
    strokeWidth: 2.712,
    rx: 10.579
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.238,
    d: "m30.166 48.117-.175 5.38M43.224 44.516l1.542 2.741M18.428 42.78l-2.865 3.937"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Thumb_svg__a",
    width: 62.114,
    height: 50.721,
    x: 0.574,
    y: 0.574,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.713
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_720_1729"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_720_1729",
    result: "shape"
  })))));
};
export default SvgThumb;